import { IconButton } from "@chakra-ui/react";
import { useState } from "react";
import { RiDeleteBinLine, RiFileEditLine } from "react-icons/ri";
import { useDispatch, useSelector } from "react-redux";
import CTable from "../../../components/Table/table";

import { openAddSectionkModel } from "../../../modules/admin-modules/models/Actions";
import { deleteSuperadminSectionRequest } from "../../../modules/superadmin-modules/sections/Actions";

const SuperadminSectionsTable = ({ setAdd, setSelectedData }) => {
  const { sections, isLoading } = useSelector(
    (state) => state.superadminSections
  );
  const dispatch = useDispatch();
  const [offset, setPage] = useState(0);
  const [size, setPerPage] = useState(10);
  const [pageNumber, setPageNumber] = useState(0);
  const [selected, setSelected] = useState({
    id: "",
  });
  const viewData = (data) => {
    setSelectedData(data);
    setSelected(data);
  };
  const Data = sections?.map((data) => {
    return {
      ...data,
      edit: (
        <IconButton
          variant="outline"
          border="0"
          color="gray.600"
          aria-label="Call Sage"
          fontSize="20px"
          icon={<RiFileEditLine />}
          onClick={() => {
            setAdd(false);
            dispatch(openAddSectionkModel());
          }}
        />
      ),
      delete: (
        <IconButton
          variant="outline"
          border="0"
          color="gray.600"
          aria-label="Call Sage"
          fontSize="20px"
          icon={<RiDeleteBinLine color="red" />}
          onClick={() => dispatch(deleteSuperadminSectionRequest(data?.id))}
        />
      ),
    };
  });
  const columns = [
    {
      Header: " ألقسم",
      accessor: "name",
    },
    {
      Header: "السنة الدراسية التابع له",
      accessor: "course.name",
    },
    {
      Header: "تعديل",
      accessor: "edit",
    },
    {
      Header: "حذف",
      accessor: "delete",
    },
  ];

  return (
    <CTable
      selectedData={viewData}
      Columns={columns}
      Data={Data}
      path={"openModel"}
      Actions
      Title={``}
      subTitle=""
      btnTitle=""
      placeHolder=""
      noSearchBar={true}
      noFilter={true}
      footerBtnTitle
      filterList
      addButton
      addButtonTitle=""
      setPage={setPage}
      setPerPage={setPerPage}
      currentpage={pageNumber}
      setPageNumber={setPageNumber}
      noSecondSearchBar={true}
      isLoading={isLoading}
      perPage={size}
      totalPage={Math.ceil(sections?.length / 10)}
    />
  );
};

export default SuperadminSectionsTable;
